import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { BaseComponent } from './base.component';
import { Situacoes } from 'app/entity/enumeraveis';
import { PadraoService } from 'app/service/padrao.service';

@Component({
    selector: 'base-list-prestacao-conta',
    template: `
    <form [formGroup]="filtro" novalidate>
        <div class="ui-g form-group ui-md-12">
            <form-text class="ui-g-12 ui-md-4 ui-lg-4" label="Pesquisar por Identificador Digital" formControlName="identificadorDigital"></form-text>
            <form-text class="ui-g-12 ui-md-4 ui-lg-4" label="Pesquisar por Nome" formControlName="nome"></form-text>
            <form-cpf class="ui-g-12 ui-md-2 ui-lg-2" label="Pesquisar por CPF" formControlName="cpf"></form-cpf>
            <form-registro-crc class="ui-g-12 ui-md-2 ui-lg-2" label="Pesquisar por Registro" formControlName="registro"></form-registro-crc>
        </div>
        <div class="ui-g form-group ui-md-12">
            <form-multi-select class="ui-g-12 ui-md-4 ui-lg-4" label="Pesquisar por Exercício(os)*" formControlName="exercicios" [options]="listaExercicios | formatSelectItem:'id':'nome'"></form-multi-select>
            <form-select class="ui-g-12 ui-md-4 ui-lg-4" *ngIf="!gestorCRC" label="Pesquisar por Lotação*" formControlName="lotacoes" [options]="listaLotacoes | formatSelectItem:'abreviacao':'nome'"></form-select>
            <form-multi-select class="ui-g-12 ui-md-4 ui-lg-4" label="Pesquisar por Situação(ões)*" formControlName="situacoes" [options]="listaSituacoes | formatSelectItem:'id':'nome'"></form-multi-select>
        <div class="ui-g-12  ui-md-12"></div>
    </div>
    </form>
    <div class="ui-g-12 ui-md-4 ui-lg-3" style="margin-right: 6%;float: right;">
        <button pButton type="button" label="Consultar" (click)="consultar($event)" class="ui-button-madison"></button>
    </div> 
    <div class="ui-g-12 ui-md-4 ui-lg-3" >
        <button pButton type="button" [label]="'Limpar'" class="ui-button-white" (click)="limpar()"></button>
    
    `})
export class BaseListFilterPrestacaoContaComponent extends BaseComponent {
    @Input() filtro: FormGroup;
    @Input() gestorCRC;
    @Input() listagem: DatatableComponent;
    listaExercicios: any[] = [];
    listaSituacoes: any[] = [
        { id: Situacoes.Iniciado, nome: "Iniciado" },
        { id: Situacoes['Em Análise'], nome: "Em Análise" },
        { id: Situacoes.Concluído, nome: "Concluído" }];
    listaLotacoes: any[] = [];

    ngOnInit(): void {
        this.listaExercicios = [];
        this.limpar();
        this.service.ListarTodosGenerics('prestacaoConta/obterExercicios').subscribe(exercicios => {
            this.listaExercicios = exercicios
        });
        this.service.ListarTodos('uf').subscribe(
            data => this.listaLotacoes = data
        );
    }

    consultar(event: any) {
        if (this.filtro.valid) {
            const params = new URLSearchParams();
            const formValue = this.filtro.value;
            this.listagem.pDatatableComponent.first = 0;

            for (const key in formValue) {
                params.append(key, formValue[key]);
            }
            sessionStorage.setItem('funcionalidade', this.router.url.split('/')[2]);
            sessionStorage.setItem('filtro', params.toString());
            this.listagem.refresh();
        }
    }

    limpar() {
        this.filtro.reset();
    }
}


// WEBPACK FOOTER //
// ./src/app/base/base-list-filter-prestacao-conta.component.ts